import React from 'react'

function Footer() {
  return (
    <footer className="w-full py-6 px-4 sm:px-6 lg:px-8 border-t border-gray-200 bg-white/50 animate-fade-in">
      <div className="max-w-6xl mx-auto text-center">
        <p className="text-gray-600 text-sm">
          © 2025 Avyrox Solutions. All rights reserved. | 
          <a 
            href="/privacy" 
            className="text-cp-primary hover:text-cp-primary/80 transition-colors duration-200 underline ml-1"
          >
            Privacy Policy
          </a>
        </p>
        <p className="text-gray-500 text-xs mt-2">
          Companion Promise - Caring for your loved ones like family
        </p>
      </div>
    </footer>
  )
}

export default Footer